import { Home, Layers, BookOpen, Star, Repeat, Users, User } from 'lucide-react';
import { useSocial } from '../hooks/useSocial';

const TABS = [
  { key: 'dashboard', label: 'Home', icon: Home },
  { key: 'series', label: 'Collection', icon: Layers, group: ['series', 'sets', 'cards'] },
  { key: 'pokedex', label: 'Pokédex', icon: BookOpen },
  { key: 'wishlist', label: 'Wishlist', icon: Star },
  { key: 'trades', label: 'Trades', icon: Repeat },
  { key: 'friends', label: 'Friends', icon: Users },
  { key: 'profile', label: 'Profile', icon: User },
];

const BottomTabBar = ({ currentView, onNavigate }) => {
  const { incoming, matches } = useSocial();
  const badgeCounts = {
    friends: incoming.length,
    trades: matches.filter((m) => m.score > 0).length
  };

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 h-20 bg-cream-card/[0.92] backdrop-blur-md border-t border-border flex z-40">
      {TABS.map((tab) => {
        const isActive = tab.group ? tab.group.includes(currentView) : currentView === tab.key;
        const Icon = tab.icon;
        return (
          <button
            key={tab.key}
            onClick={() => onNavigate(tab.key)}
            className="flex-1 flex flex-col items-center justify-center gap-1"
          >
            <span className="relative">
              <Icon
                size={20}
                className={isActive ? 'text-navy-dark' : 'text-ink-faint'}
                strokeWidth={isActive ? 2.5 : 2}
              />
              {badgeCounts[tab.key] > 0 && (
                <span className="absolute -top-1.5 -right-2 min-w-[15px] h-[15px] px-0.5 rounded-full bg-brick text-white text-[9px] font-bold flex items-center justify-center">
                  {badgeCounts[tab.key]}
                </span>
              )}
            </span>
            <span className={`text-[10px] ${isActive ? 'font-bold text-navy-dark' : 'text-ink-faint'}`}>
              {tab.label}
            </span>
            {isActive && <span className="w-1 h-1 rounded-full bg-yellow" />}
          </button>
        );
      })}
    </div>
  );
};

export default BottomTabBar;
